<template>
    <div id="modal-lite-holder">
        <ModalRequestCustomDesign/>
        <ModalFeedback/>
        <ModalGetPrice/>
        <ModalShowPhotoInResult/>
        <modals-container/>
    </div>
</template>

<script>
    import ModalRequestCustomDesign from "./ModalRequestCustomDesign";
    import ModalFeedback from "./ModalFeedback";
    import ModalShowPhotoInResult from "./ModalShowPhotoInResult";
    import ModalGetPrice from "./ModalGetPrice";

    export default {
        name: "TheLiteModal",
        components: {
            ModalGetPrice,
            ModalShowPhotoInResult,
            ModalFeedback,
            ModalRequestCustomDesign
        }
    }
</script>
